import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ImageSliderProps {
  images: string[];
  alt: string;
  className?: string;
}
export function ImageSlider({
  images,
  alt,
  className = ''
}: ImageSliderProps) {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const paginate = (newDirection: number) => {
    setDirection(newDirection);
    setIndex(prev => (prev + newDirection + images.length) % images.length);
  };
  const goTo = (i: number) => {
    setDirection(i > index ? 1 : -1);
    setIndex(i);
  };
  if (images.length === 0) return null;
  return <div className={`relative w-full h-full overflow-hidden bg-brand-cream ${className}`} data-id="element-277">
      <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-278">
        <motion.img key={index} src={images[index]} alt={`${alt} — фото ${index + 1}`} custom={direction} initial={{
        opacity: 0,
        x: direction > 0 ? 60 : -60
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: direction > 0 ? -60 : 60
      }} transition={{
        duration: 0.4,
        ease: 'easeInOut'
      }} className="absolute inset-0 w-full h-full object-cover" data-id="element-279" />
      </AnimatePresence>

      {images.length > 1 && <>
          <button onClick={() => paginate(-1)} aria-label="Попереднє фото" className="absolute left-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-white/80 backdrop-blur-md text-brand-dark flex items-center justify-center hover:bg-white transition-colors shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-burgundy" data-id="element-280">
            <ChevronLeft className="w-5 h-5" data-id="element-281" />
          </button>
          <button onClick={() => paginate(1)} aria-label="Наступне фото" className="absolute right-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-white/80 backdrop-blur-md text-brand-dark flex items-center justify-center hover:bg-white transition-colors shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-burgundy" data-id="element-282">
            <ChevronRight className="w-5 h-5" data-id="element-283" />
          </button>

          <div className="absolute bottom-4 left-0 right-0 z-10 flex justify-center gap-2" data-id="element-284">
            {images.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Перейти до фото ${i + 1}`} className={`h-2 rounded-full transition-all ${i === index ? 'w-6 bg-brand-burgundy' : 'w-2 bg-white/70 hover:bg-white'}`} data-id="element-285" />)}
          </div>
        </>}
    </div>;
}